import { useCallback, useState } from "react";

import client from "../../client";
import { handleToast } from "../../../utils/functions";
import handleApiError from "../../../hooks/handleApiError";

export default function useCreateSubject() {
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (category, payload) => {
    try {
      setLoading(true);

      const res = await client.post(`/curriculum/${category}`, payload);

      handleToast(res.data?.message);
      setLoading(false);

      return true;
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  return { request, loading };
}
